module.exports = __webpack_public_path__ + "img/shortPause.67398ae8.svg";